import styled from "styled-components";
import { rgba, colorsPalettes } from "@similarweb/styles";
import { setFont } from "@similarweb/styles";

const { carbon } = colorsPalettes;

export const Bullet = styled.div<{ color: string }>`
    display: inline-flex;
    border-radius: 50%;
    margin-right: 5px;
    margin-top: 6px;
    width: 7px;
    height: 7px;
    ${({ color }) => `background-color:${color};`};
`;

export const TooltipContainer = styled.div`
    width: 230px;
    padding: 15px;
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 0 3px 6px 0 ${rgba(colorsPalettes.carbon[200], 0.5)};
    border-radius: 5px;
`;

export const Text = styled.label<{ color?: string }>`
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: inherit;
    width: fit-content;
    ${({ color = carbon[500] }) => setFont({ $size: 15, $color: color })};
`;

export const Header = styled(Text)`
    ${setFont({ $size: 12, $color: rgba(carbon[500], 0.8) })};
`;

export const HeadersContainer = styled.div`
    display: flex;
    justify-content: space-between;
    padding-bottom: 9px;
`;

export const ListItemContainer = styled.div`
    display: flex;
    justify-content: space-between;
    height: 24px;
`;

export const FlexRow = styled.div`
    display: flex;
`;
